/** 天地图开发密钥 */
export const TIANDITU_TK = '012930268d06a0daf66cafd7d2c0f45e'

/**
 * 动态加载天地图 JavaScript API 4.0
 * @returns {Promise<typeof window.T>}
 */
export function loadTianditu() {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.T && window.T.Map) {
      resolve(window.T)
      return
    }
    if (!TIANDITU_TK || TIANDITU_TK === 'your_tianditu_tk') {
      reject(new Error('请先在 src/utils/tianditu.js 中配置天地图密钥 TIANDITU_TK'))
      return
    }
    const existing = document.querySelector('script[data-tianditu-api]')
    if (existing) {
      existing.addEventListener('load', () => resolve(window.T))
      existing.addEventListener('error', reject)
      return
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.dataset.tiandituApi = '1'
    script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_TK}`
    script.onload = () => {
      if (window.T && window.T.Map) {
        resolve(window.T)
      } else {
        reject(new Error('天地图 API 加载失败'))
      }
    }
    script.onerror = reject
    document.head.appendChild(script)
  })
}
